import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();
  const startYear = 2025; // Replace with your start year

  // Conditionally set the year range
  const yearText =
    currentYear === startYear
      ? `${startYear}`
      : `${startYear} - ${currentYear}`;

  return (
    <div className="footer p-2 fixed-bottom ">
      <div className="container-fluid d-flex justify-content-between">
        <p>© {yearText} All rights reserved.</p>
        <p>Version 2.0</p>
      </div>
    </div>
  );
}

export default Footer;
